import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { APIClient } from "@/api/axiosClient";
import { BASE_URL } from "@/config";

function getDashboardType(pathname) {
  if (pathname.startsWith("/rewardpoint")) return "REWARD_POINT";
  if (pathname.startsWith("/xpandpoint")) return "XPAND_POINT";
  // Default to ACCESS_POINT for root and /analytics
  return "ACCESS_POINT";
}

function getClientIdIfProgramAdmin() {
  try {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo") || "null");
    if (
      userInfo &&
      userInfo.roleCode === "PROGRAM_ADMIN" &&
      userInfo.clientId
    ) {
      return userInfo.clientId;
    }
  } catch (e) {}
  return null;
}

export default function Analytics() {
  const location = useLocation();
  const [iframeUrl, setIframeUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    const dashboardType = getDashboardType(location.pathname);
    setLoading(true);
    setError("");
    setIframeUrl("");
    setIframeLoaded(false);
    APIClient(
      "/metabase/prepareMetabaseDashBoardLink",
      { dashboardType },
      {
        requestType: "post",
        contentType: "application/json",
        baseUrl: BASE_URL,
      }
    )
      .then((res) => {
        if (res.data && res.data.dashBoardUrl) {
          let url = res.data.dashBoardUrl;
          const clientId = getClientIdIfProgramAdmin();
          if (clientId) {
            url += (url.includes("?") ? "&" : "?") + `client_id=${clientId}`;
          }
          setIframeUrl(url);
        } else {
          throw new Error("No dashboard URL returned");
        }
      })
      .catch((err) => {
        setError(err.message || "Unknown error");
      })
      .finally(() => setLoading(false));
  }, [location.pathname]);

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-bold text-gray-800">
          Analytics Dashboard
        </h1>
        <p className="text-gray-500 mt-1">
          View comprehensive analytics and insights for your program.
        </p>
      </div>
      {(loading || (iframeUrl && !iframeLoaded)) && (
        <div className="flex items-center justify-center h-40">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-500" />
          <span className="ml-3 text-gray-500">Loading dashboard...</span>
        </div>
      )}
      {error && <div style={{ color: "red" }}>Error: {error}</div>}
      {!loading && !error && iframeUrl && (
        <iframe
          src={iframeUrl}
          title="Analytics Dashboard"
          style={{ width: "100%", height: "80vh", border: "none" }}
          allowFullScreen
          onLoad={() => setIframeLoaded(true)}
        />
      )}
    </div>
  );
}
